import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { X, Upload, CheckCircle, Users } from 'lucide-react';

interface BatchInviteModalProps {
  companyId: string;
  onClose: () => void;
  onInvitesSent: () => void;
}

export const BatchInviteModal: React.FC<BatchInviteModalProps> = ({
  onClose,
  onInvitesSent,
}) => {
  const { t } = useLanguage();
  const [csvText, setCsvText] = useState("email,name\nalice@company.com,Alice Smith\nbob@company.com,Bob Jones\ncarla@company.com,Carla Lopez");
  const [loading, setLoading] = useState(false);
  const [successCount, setSuccessCount] = useState<number | null>(null);

  const handleSendInvites = () => {
    setLoading(true);
    setTimeout(() => {
      const lines = csvText.split('\n').filter((l) => l.includes('@'));
      setSuccessCount(lines.length);
      setLoading(false);
      onInvitesSent();
    }, 1200);
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <Users size={22} color="var(--accent-primary)" />
            <h3 style={{ fontSize: '18px' }}>{t('Invitación Masiva de Empleados (CSV)', 'Batch Employee Invitation (CSV)')}</h3>
          </div>
          <button className="btn btn-secondary" style={{ padding: '6px' }} onClick={onClose}>
            <X size={16} />
          </button>
        </div>

        {successCount === null ? (
          <div>
            <p style={{ fontSize: '13px', color: 'var(--text-secondary)', marginBottom: '12px' }}>
              {t(
                'Pegue o escriba la lista de correos electrónicos de sus empleados en formato CSV (email, nombre). Se les enviará un enlace de acceso seguro y se matricularán automáticamente en los 5 cursos obligatorios.',
                'Paste or upload your employee email list in CSV format (email, name). They will receive secure sign-in links and auto-enroll in all mandatory courses.'
              )}
            </p>

            <textarea
              className="input-field"
              rows={8}
              style={{ fontFamily: 'monospace', fontSize: '12px', marginBottom: '16px' }}
              value={csvText}
              onChange={(e) => setCsvText(e.target.value)}
            />

            <button
              className="btn btn-primary"
              style={{ width: '100%', padding: '12px' }}
              disabled={loading || !csvText.trim()}
              onClick={handleSendInvites}
            >
              <Upload size={16} />
              {loading ? t('Procesando e Inscribiendo...', 'Processing & Auto-Enrolling...') : t('Enviar Invitaciones Masivas', 'Dispatch Batch Invites')}
            </button>
          </div>
        ) : (
          <div style={{ textAlign: 'center', padding: '20px 0' }}>
            <CheckCircle size={48} color="var(--accent-success)" style={{ marginBottom: '12px' }} />
            <h4>{t('¡Invitaciones Procesadas con Éxito!', 'Batch Invites Dispatched Successfully!')}</h4>
            <p style={{ fontSize: '14px', color: 'var(--text-secondary)', margin: '8px 0 20px' }}>
              {successCount} {t('empleados han sido aprovisionados y matriculados en los cursos obligatorios.', 'employees provisioned and auto-enrolled in compliance courses.')}
            </p>
            <button className="btn btn-primary" onClick={onClose}>
              {t('Cerrar y Actualizar Métricas', 'Close & Refresh Metrics')}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
